import {Component, OnInit} from '@angular/core';
import {icon, latLng, LeafletMouseEvent, Map, Marker, marker, tileLayer} from 'leaflet';
import {LeafletModule} from "@bluehalo/ngx-leaflet";

@Component({
  selector: 'app-map',
  standalone: true,
  imports: [LeafletModule],
  templateUrl: './map.component.html',
  styleUrl: './map.component.scss'
})
export class MapComponent implements OnInit {

  options = {
    layers: [
      tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      })
    ],
    zoom: 18,
    // center: latLng(51.505, -0.09) // Center at London
    // center: latLng(15.5779976, 100.7175042)
    center: latLng(15.599, 100.6604)
    // center: latLng(13.759887, 100.483429)
  };

  layers: Marker[] = [
    marker([51.505, -0.09], {
      icon: icon({
        iconSize: [25, 41],
        iconAnchor: [13, 41],
        iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png'
      })
    })
  ];

  ngOnInit(): void {
  }

  map!: Map; // Reference to the Leaflet map instance
  currentMarker!: Marker; // Reference to the current marker

  onMapReady(map: Map) {
    this.map = map;

    // Drop a pin at the clicked location
    this.addMarker(15.599, 100.6604);
    // this.addMarker(13.759887, 100.483429);

    // Fetch JSON data (e.g., reverse geocoding)
    this.fetchJsonData(15.599, 100.6604);
    // this.fetchJsonData(13.759887, 100.483429);

    this.getSuburbFromOverpass(15.599, 100.6604);

    // Add a click listener to the map
    this.map.on('click', (event: LeafletMouseEvent) => {
      const {lat, lng} = event.latlng;
      console.log(`Clicked at Latitude: ${lat}, Longitude: ${lng}`);

      // Drop a pin at the clicked location
      this.addMarker(lat, lng);

      // Fetch JSON data (e.g., reverse geocoding)
      // this.fetchJsonData(lat, lng);
      this.fetchJsonData(lat, lng);
    });
  }

  addMarker(lat: number, lng: number) {
    // Remove the previous marker if it exists
    if (this.currentMarker) {
      this.map.removeLayer(this.currentMarker);
    }

    // Create and add a new marker
    this.currentMarker = marker([lat, lng], {
      icon: icon({
        iconSize: [25, 41],
        iconAnchor: [13, 41],
        iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png'
      })
    }).addTo(this.map);
  }

// Fetch JSON data from OpenStreetMap's Nominatim API
  fetchJsonData(lat: number, lng: number) {
    const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&accept-language=th&addressdetails=1`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        console.log('Fetched JSON Data:', data);

        // Extract and display address in Thai
        const address = data.display_name || 'ไม่พบข้อมูลที่อยู่';
        this.currentMarker.bindPopup(`ข้อมูลที่อยู่: ${address}`).openPopup();
      })
      .catch((error) => {
        console.error('Error fetching JSON data:', error);
        this.currentMarker.bindPopup('เกิดข้อผิดพลาดในการดึงข้อมูล').openPopup();
      });
  }

  getSuburbFromOverpass(lat, lon) {
    const url = `https://overpass-api.de/api/interpreter?data=[out:json];node["admin_level"="8"](around:100,${lat},${lon});out;`;
    fetch(url)
      .then(response => response.json())
      .then(data => {
        console.log('overpass data: ', data)
        const suburb = data.elements.length > 0 ? data.elements[0].tags.name : 'No suburb found';
        console.log('Suburb:', suburb);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

}
